module.exports = __webpack_public_path__ + "assets/img/2d66079316fde41dca307213df62c450.svg";